// removed by extract-text-webpack-plugin
module.exports = {"boldText":"_1eTbUvaItKhKsZ_Bo3jMcl","centered":"_1kVGUySl5ltj2Tdhzb5FwP","notBold":"_3AjdwMATt0H4kKR7vV7zza","quantity":"_2dYElSuDn34BpPmj1WtXZP","indented":"_3SYyE2CK7YoGKJ-sUwcdLH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HighlightTitleForPackage/HighlightTitleForPackage.scss
// module id = 1610
// module chunks = 0